import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import * as api from "../../../api";
import {useFeedbackTools} from "../../../components/FeedbackTools";


export const useCreateUser = () => {
    const {t} = useTranslation(["users"])
    const queryClient = useQueryClient();
    const {showSuccessNotification}  = useFeedbackTools();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: async (data) => await api.User.createUser(data),
        onSuccess: (data) => {
            queryClient.invalidateQueries(['users']);
            showSuccessNotification(t('query.success'));
            navigate(`/users/${data.id}`);
        }
    });
}